import styled from "styled-components";

export const Title = styled.h3`
  text-align: center;
  font-size: 28px;
  margin-bottom: 12px;
`;

export const Forma = styled.form`
  background-color: #ffffff;
  width: 400px;
  margin: 0 auto;
  padding: 20px 40px;
  border-radius: 20px;
`;

export const Input = styled.input`
  background-color: #ffffff;
  border: #9557e8 2px solid;
  color: #9557e8;
  padding: 6px 20px;
  font-size: 14px;
  width: 100%;
  border-radius: 20px;
  margin-bottom: 8px;
`;
